import { AuthConfig } from 'angular-oauth2-oidc';

export const oauthConfig: AuthConfig = {

  // Authorization Server Issuer URL
  issuer: 'https://sso.id.eurofins.com',
  redirectUri: 'https://reviewcenter.alm.eurofins.com/',
  clientId: 'ReviewCenterApp_Prod',
  strictDiscoveryDocumentValidation: true,
  responseType: 'code',
  scope: 'openid profile',
  oidc: true,
  requestAccessToken: true,
  disablePKCE: false,
  showDebugInformation: true
};
